/** The browser database holding unsent marks; cleared on sign-out (Part 6.3). */
export const OUTBOX_DB = 'revu-outbox'
